import {
  GeneratedOpcUaClientCertificate,
  mapGenerateOpcUaClientCertificateResponse,
  postGenerateOpcUaClientCertificate,
} from "@src/cloud-connect/api/client-configuration/post-generate-opcua-client-certificate";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface GenerateOpcUaClientCertificateResult {
  success: boolean;
  data?: GeneratedOpcUaClientCertificate;
  error?: string;
  errorData?: unknown;
  status?: number;
}

export const generateOpcUaClientCertificateUseCase = async (
  hostnames: string[] = [],
): Promise<GenerateOpcUaClientCertificateResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await postGenerateOpcUaClientCertificate(
      namespace,
      hostnames,
    );

    const certificate = mapGenerateOpcUaClientCertificateResponse(
      response.data,
    );

    if (
      !certificate.clientCertificateBase64.trim() ||
      !certificate.clientCertificatePrivateKeyBase64.trim()
    ) {
      return {
        success: false,
        error: "The certificate service returned an incomplete certificate.",
        status: response.status,
      };
    }

    return {
      success: true,
      data: certificate,
      status: response.status,
    };
  } catch (error) {
    const parsed = parseAxiosApiError(
      error,
      "Failed to generate the certificate.",
    );

    return {
      success: false,
      error: parsed.message,
      errorData: parsed.data,
      status: parsed.status,
    };
  }
};
